import { apiSlice } from "../../app/api/apiSlice";

export const homeApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getHomePageStatistics: builder.query({
            query: () => '/home/statistics',
            keepUnusedDataFor: 5,
            providesTags: ['job', 'user']
        }),
        getPopularCategories: builder.query({
            query: () => '/popular/categories',
            keepUnusedDataFor: 5
        }),
        getRecentJobsList: builder.query({
            query: () => `/recent/jobs`,
            keepUnusedDataFor: 5,
            providesTags: ['job']
        }),
        getHighestRatedMasters: builder.query({
            query: () => `/jobs/masters/highestRated`,
            keepUnusedDataFor: 5,
            providesTags: ['user']
        }),
    })
});

export const {
    useGetHomePageStatisticsQuery,
    useGetPopularCategoriesQuery,
    useGetRecentJobsListQuery,
    useGetHighestRatedMastersQuery,
} = homeApiSlice

